<template>
  <div>
  <!-- 表头查询 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="5">
            <a-form-model-item label="机台编号" prop="deviceNo">
              <a-input v-model="formInline.deviceNo" placeholder="请输入机台编号"> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="getAllDeviceNo">
                查询
              </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-col :span="6">
                <a-button style="margin-left: 10px" @click="resetForm">
                  重置
                </a-button>
              </a-col>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    

  <!-- 表单 -->
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
    
  >
  <!-- <div class="setting" >

    <div class="setting-device" >
      <a-input type="text" v-model="deviceNo" placeholder="请输入机台号" />
      <a-button type="primary" @click="clearByDeviceNo(deviceNo)" :style="{ margin: '0 0 24px 0' }">
        解锁占用机台
      </a-button>
    </div>
  </div> -->
  <a-switch v-model="checked" @change="checkedChange" />
  <p style="margin-top: 10px;">开启扫码专用，如果启用专户专用，机台将只能被绑定的用户使用，除非后台解锁占用机台，此功能只针对小程序扫码用户</p>
   
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="middle"
    >

      <template slot="operation" slot-scope="text, operation">
        <a href="javascript:;" @click="clearByDeviceNo(operation.deviceNo)">解锁</a>
      </template>
    </a-table>
  </div>
  </div>
</template>
<script>

import { clearDeviceNo,getDeviceNo,storeFunctionList,storeCoinnumEnable } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
import { computed } from "@vue/composition-api";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
  },
  {
    title: "机台号",
    dataIndex: "deviceNo",
  },
  {
    title: "用户uerId",
    dataIndex: "userId",
  },
  {
    title: "卡号",
    dataIndex: "cardNo",
  },
  {
    title: "手机号码",
    dataIndex: "mobile",
    sorter: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    sorter: true,
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      formInline: {
        deviceNo: "",
        pageNo: 1,
        pageSize: 10,
      },
      checked: false,
    };
  },
  mounted() {
    this.getAllDeviceNo();
    this.getStoreFunction();

  },

  methods: {
    clearByDeviceNo(deviceNo) {
      if (!deviceNo) {
        return message.error("请输入机台号");
      }
      clearDeviceNo(deviceNo).then((res) => {
        message.success(res.info);
        this.getAllDeviceNo();
      });
    },

    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      getDeviceNo({ pageSize: 10, pageNo: this.pagination.current }).then((res) => {
        this.data = res.data;
        this.pagination.total = res.count;
        this.loading = false;
      });
    },

    getAllDeviceNo() {
      getDeviceNo(this.formInline).then((res) => {
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    resetForm(){
      this.formInline.deviceNo = "";
      this.formInline.pageNo = 1;
      this.formInline.pageSize = 10;
      this.getAllDeviceNo();
    },
    async getStoreFunction() {
      await storeFunctionList(26).then((res) => {
        this.Details = res.data;
        if(this.Details && this.Details[0]){
          this.checked = this.Details[0].isUse === 1 ? true : false;
        }
      });
    },
    checkedChange(item){
      console.log(item);
      if(item){
        this.isUse = 1;
      }else{
        this.isUse = 0;
      }
        storeCoinnumEnable(this.isUse,26).then((res) => {
          this.getStoreFunction();
          message.success(res.data);
        });
      
    },

 
  },
};
</script>
<style scoped>
.packageName {
  margin: 10px 0;
}
.setting {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 24px;
  align-items: stretch;
  margin-right: 100px;
  gap: 24px;
}
.setting-coins,
.setting-device {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 200px;
  gap: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/storeManagement/deviceUsingReport/deviceUsingReportHome.vue